import * as Sentry from '@sentry/react'

const addTrackingError = (message: string) => {
  try {
    Sentry.captureMessage(message)
  } catch (error) {
    console.error(error)
  }
}

export default addTrackingError
